module.exports = __webpack_public_path__ + "static/img/01.a46d7af2.gif";